module.exports = __webpack_public_path__ + "img/人体健康管理.ac57e242.png";